import { readAttrCookie, computeFirstTouch } from "../shared/attribution/firstTouch";

(function () {
  var existing = readAttrCookie(document.cookie);
  var payload = computeFirstTouch({
    existingCookie: existing,
    referrer: document.referrer,
    href: window.location.href,
    now: Date.now()
  });
  if (!payload) return; // first-touch already captured

  var host = window.location.hostname.replace(/^www\./i, "");
  var value = encodeURIComponent(JSON.stringify(payload));
  // 30 days; domain scoped to registrable-ish host so www/apex share it.
  document.cookie =
    "od_attr=" + value +
    ";path=/;max-age=2592000;domain=." + host + ";SameSite=Lax;Secure";
})();
